import { Link } from "react-router-dom";
import { categories } from "@/mocks/comics";

export default function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-background-950 text-foreground-100">
      <div className="max-w-[1400px] mx-auto px-4 md:px-6 py-12">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
          <div>
            <h4 className="text-lg font-bold font-heading text-background-50 mb-4">
              韩漫屋
            </h4>
            <p className="text-sm text-foreground-400 leading-relaxed">
              韩漫网站免费在线阅读平台，提供海量无删减韩国漫画。下拉式阅读体验，每日更新，让您随时随地享受漫画乐趣。
            </p>
          </div>

          <div>
            <h4 className="text-sm font-semibold font-label text-background-50 mb-4">
              快速链接
            </h4>
            <ul className="flex flex-col gap-2">
              <li>
                <Link
                  to="/"
                  className="text-sm text-foreground-400 hover:text-primary-400 transition-colors cursor-pointer"
                >
                  首页
                </Link>
              </li>
              <li>
                <Link
                  to="/category/all"
                  className="text-sm text-foreground-400 hover:text-primary-400 transition-colors cursor-pointer"
                >
                  漫画分类
                </Link>
              </li>
              <li>
                <Link
                  to="/about"
                  className="text-sm text-foreground-400 hover:text-primary-400 transition-colors cursor-pointer"
                >
                  关于我们
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold font-label text-background-50 mb-4">
              热门分类
            </h4>
            <ul className="flex flex-col gap-2">
              {categories.slice(0, 6).map((cat) => (
                <li key={cat.slug}>
                  <Link
                    to={`/category/${cat.slug}`}
                    className="text-sm text-foreground-400 hover:text-primary-400 transition-colors cursor-pointer"
                  >
                    {cat.name}漫画
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold font-label text-background-50 mb-4">
              联系我们
            </h4>
            <ul className="flex flex-col gap-2 text-sm text-foreground-400">
              <li>邮箱：contact@hanmanwu.com</li>
              <li>QQ群：123456789</li>
              <li className="flex items-center gap-3 mt-2">
                <a
                  href="#"
                  className="w-8 h-8 flex items-center justify-center rounded-full bg-foreground-800 hover:bg-primary-600 transition-colors cursor-pointer"
                  aria-label="微博"
                  rel="nofollow"
                >
                  <i className="ri-weibo-line text-sm"></i>
                </a>
                <a
                  href="#"
                  className="w-8 h-8 flex items-center justify-center rounded-full bg-foreground-800 hover:bg-primary-600 transition-colors cursor-pointer"
                  aria-label="微信"
                  rel="nofollow"
                >
                  <i className="ri-wechat-line text-sm"></i>
                </a>
                <a
                  href="#"
                  className="w-8 h-8 flex items-center justify-center rounded-full bg-foreground-800 hover:bg-primary-600 transition-colors cursor-pointer"
                  aria-label="QQ"
                  rel="nofollow"
                >
                  <i className="ri-qq-line text-sm"></i>
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-foreground-800 mt-10 pt-6 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-foreground-500">
            &copy; {currentYear} 韩漫屋 hanmanwu.com - 韩漫网站免费在线阅读平台 版权所有
          </p>
          <p className="text-xs text-foreground-500">
            本站所有漫画均来自网络，仅供学习交流使用
          </p>
        </div>
      </div>
    </footer>
  );
}